import React from "react";
import ArticleNavigationTab from "./ArticleNavigationTab";

const ArticleNavigation = ({
    articles,
    assetURL,
    currentArticle
}) => {
    const { articleNo } = currentArticle;
    const currentIndex = articles.indexOf(articles.find(article => articleNo === article.articleNo));
    const previousArticleIndex = currentIndex <= 0 ? -1 : currentIndex - 1;
    const nextArticleIndex = currentIndex === -1 || currentIndex === articles.length - 1 ? -1 : currentIndex + 1;

    return (
        <div className="ArticleNavigation">
            {previousArticleIndex !== -1
                ? <ArticleNavigationTab
                    isNext={false}
                    article={articles[previousArticleIndex]}
                    assetURL={assetURL}
                />
                : null
            }
            {nextArticleIndex !== -1
                ? <ArticleNavigationTab
                    isNext={true}
                    article={articles[nextArticleIndex]}
                    assetURL={assetURL}
                />
                : null
            }
        </div>
    );
};

export default ArticleNavigation;